var React = require('react');

function StatusRunning (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"d":"M16 32C7.16 32 0 24.84 0 16S7.16 0 16 0s16 7.16 16 16-7.16 16-16 16zm8-14c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-8 0c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-8 0c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z","key":0}),React.createElement("path",{"d":"M24 18c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-8 0c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-8 0c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z","key":1}),React.createElement("circle",{"fill":"#FFF","cx":"8","cy":"16","r":"2","key":2}),React.createElement("circle",{"fill":"#FFF","cx":"16","cy":"16","r":"2","key":3}),React.createElement("circle",{"fill":"#FFF","cx":"24","cy":"16","r":"2","key":4})]));
}

StatusRunning.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = StatusRunning;

StatusRunning.default = StatusRunning;
